module.exports = __webpack_public_path__ + "static/img/day_report_fail.00bbff18.png";